import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import { useWorkflowAssignments } from 'src/graphql/entities/workflow/hooks/use-workflow-assignments';
import { useWorkflowsByTrigger } from 'src/graphql/entities/workflow/hooks/use-workflows-by-trigger';

/**
 * Warms the three queries the assignments modal needs, from the page that opens it. Only the
 * open modal is mounted, so it cannot prefetch for itself and would open onto empty selects.
 *
 * The arguments must stay identical to the modal's, or the two sets of queries land under
 * different cache keys and this buys nothing.
 */
export function usePrefetchWorkflowAssignments(partnerId?: number | null): void {
  useWorkflowsByTrigger(PLATFORM_PARTNER_ID, { includeWithoutActiveVersion: true });
  useWorkflowsByTrigger(partnerId, { includeWithoutActiveVersion: true });
  useWorkflowAssignments(partnerId);
}
